<div class="card">
	<div class="card-header">
		<h1>Partners Asociados <!-- <i (click)="showModalCreate = true" tooltip="Agregar Empresa Asociada"
				class="clickeable fa fa-circle-plus text-info"></i> --></h1>
	</div>
	<div class="card-body">
		<div class="row">
			<svg id="svg-container" #svgContainer></svg>
			<div class="col">
				<div class="form-group">
					<label for="searchAssociatePartner" class="form-label">Buscar partner </label>
					<input type="text" placeholder="Ingresa nombre del partner" (input)="writePartner()"
						[(ngModel)]="filterPartners" id="searchAssociatePartner" name="searchAssociatePartner"
						class="form-control">
				</div>
				<div class="table-responsive mt-3" [class.table-responsive-without]="queueDelete">
					<table class="table table-bordered" id="table-partners" name="table-partners" style="margin-bottom: 0;">
						<thead>
							<tr class="tr-middle">
								<th></th>
								<th>Email</th>
								<th>Nombre</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let associate of partners">
								<tr [class.hide-all]="queueDelete?.id==associate.id" class="item tr-middle"
									(click)="selectRow('table-partners', associate)"
									[class.selected]="associate.id == partnerId">
									<td>
										<span class="icon clickeable">
											<span class="superposition-container">
												<i [ngClass]="associate.loading?'fa fa-circle-notch':'fas fa-building'"></i>
												<i [ngClass]="associate.showCompany?'fa-eye-slash':'fa-eye'"
													class="fa-solid superposition-element"></i>
											</span>
										</span>
									</td>
									<td>{{associate.email}}</td>
									<td>{{associate.name}}</td>
									<!-- <td>
										<div style="display: flex; justify-content: space-evenly;">
											<div class="container-superposition" title="Eliminar">
												<div class="element-superposition" *ngIf="queueDelete?.id == associate.id">
													<span>¿Está seguro que desea eliminar esta empresa?</span>
													<span class="a-container">
														<span class="clickeable text-info" (click)="queueDelete = null"><i
																class="fa fa-ban"></i>NO</span>
														<span class="clickeable text-danger"><i class="fa fa-trash"
																(click)="confirmDelete(associate)"></i>SÍ</span>
													</span>
												</div>
												<span class="clickeable text-danger" (click)="deleteAssociate(associate)">
													<i *ngIf="!deleting[associate.id]" class="fa fa-trash"></i>
													<span *ngIf="deleting[associate.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
												</span>
											</div>
										</div>
									</td> -->
									<td>
										<i
											[ngClass]="associate.id == partnerId?'fa-solid fa-circle':'fa-regular fa-circle'"></i>
									</td>
								</tr>
							</ng-container>
							<tr class="tr-middle" *ngIf="partners.length == 0">
								<td colspan="4" class="text-muted">
									<i class="fa fa-circle-info"></i> {{failedStart?
									'No se pudieron obtener las empresas asociadas, fallo en el servidor'
									:'No se encontraron resultados'}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-simple-pagination id="partners-pag" (changed)="partnerId = null; getPartners()" [sizes]="[5]"
					[elements]="paginationPartners"></app-simple-pagination>
			</div>
			<div class="col">
				<div class="form-group">
					<label for="searchCompany" class="form-label">Buscar empresa asociada </label>
					<input type="text" placeholder="Ingresa nombre de empresa no asociada" (input)="writeCompany()"
						[(ngModel)]="filterCompanies" id="searchCompany" name="searchCompany" class="form-control">
				</div>
				<div class="table-responsive mt-3" [class.table-responsive-without]="queueDelete">
					<table class="table table-bordered" id="table-associated" name="table-associated"
						style="margin-bottom: 0;">
						<thead>
							<tr class="tr-middle">
								<th></th>
								<th>NIT</th>
								<th>Nombre</th>
							</tr>
						</thead>
						<tbody>
							<tr class="item tr-middle"
								*ngFor="let item of companies"
								(click)="selectRow('table-associated', item)"
								[class.selected]="currentAssociations[item.id]"
								[attr.data-id]="item.id">
								<td>
									<i
										[ngClass]="currentAssociations[item.id]?'fa-solid fa-circle':'fa-regular fa-circle'"></i>
								</td>
								<td>{{item.nit}}</td>
								<td>{{item.name}}</td>
								<!-- <td>
			
									<div style="display: flex; justify-content: space-evenly;">
										<div class="container-superposition" title="Eliminar">
											<div class="element-superposition" *ngIf="queueDelete?.id == associate.id">
												<span>¿Está seguro que desea eliminar esta empresa?</span>
												<span class="a-container">
													<span class="clickeable text-info" (click)="queueDelete = null"><i
															class="fa fa-ban"></i>NO</span>
													<span class="clickeable text-danger"><i class="fa fa-trash"
															(click)="confirmDelete(associate)"></i>SÍ</span>
												</span>
											</div>
											<span class="clickeable text-danger" (click)="deleteAssociate(associate)">
												<i *ngIf="!deleting[associate.id]" class="fa fa-trash"></i>
												<span *ngIf="deleting[associate.id]"
													class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span>
										</div>
									</div>
								</td> -->
							</tr>
							<tr class="tr-middle" *ngIf="companies.length == 0">
								<td colspan="4" class="text-muted">
									<i class="fa fa-circle-info"></i> {{failedStart?
									'No se pudieron obtener las empresas asociadas, fallo en el servidor'
									:'No se encontraron resultados'}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-simple-pagination id="companies-pag" [sizes]="[5]"
					(changed)="companyId = null; getCompaniesIsAssociated()"
					[elements]="paginationCompanies"></app-simple-pagination>
			</div>
		</div>
		<!-- <div style="margin-top: 1em; width: 100%; display: flex; justify-content: center;">
			<app-loading-button [disabled]="!partnerId || !companyId" [object]="buttonAssociate"
				(clicked)="associateToPartner()"></app-loading-button>
		</div> -->
	</div>
</div>
<div class="hide-background" *ngIf="queueDelete">
	<div class="for-click" (click)="queueDelete = null"></div>
</div>
<app-modal-associate-company *ngIf="showModalCreate" (close)="closeModalCreate($event)"></app-modal-associate-company>